import { isNilOrEmpty } from '@seedcloud/ramda-extra'
import { Form, Formik as FormProvider } from 'formik'
import Modal from 'react-modal'
import * as Validator from 'yup'

import { FieldGroup as FieldGroupBase, Row, TextField } from '../common'

import { Button } from 'components/common/Button'
import { styled, apply } from 'lib/styled'

const { object, string, number } = Validator

const requiredString = (label) => string().required().label(label)

const validationSchema = object({
  description: requiredString('Pilot Category'),
  rate: number().positive().integer().required().label('Pilot rate'),
})

const Root = styled.div(apply('text-blwack bg-white rounded-lg'), {
  padding: '40px',
  width: '646px',
  maxWidth: '646px',
})

const FieldGroup = styled(FieldGroupBase)({
  marginBottom: 0,
})

const ActionButton = styled(Button)(apply('flex-1 mt-5'), {
  marginTop: '1rem',
})

const CancelButton = styled(ActionButton)({
  background: 'transparent',
  boxShadow: 'none',
})

Modal.setAppElement('#root')

function PilotCategoryModal({
  isOpen,
  closeModal,
  title,
  currency,
  initialValues,
  onSubmit,
  loading,
}) {
  const initialFormValues = isNilOrEmpty(initialValues)
    ? {
        description: '',
        rate: '',
      }
    : { ...initialValues }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => closeModal()}
      id="unique"
      style={{
        overlay: apply('z-4 p-0 flex items-center justify-center', {
          backgroundColor: 'rgba(20, 20, 20, 0.2)',
        }),
        content: apply('p-0 bg-transparent border-0', {
          inset: 'unset',
          top: '25%',
        }),
      }}
    >
      <Root>
        <FormProvider
          enableReinitialize
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          <Form>
            <FieldGroup title={title}>
              <Row>
                <TextField
                  label="Pilot Category"
                  name="description"
                  asInput
                  disabled={loading}
                />
                <TextField
                  label={`Rate (${currency}/hr)`}
                  type="number"
                  name="rate"
                  asInput
                  disabled={loading}
                />
              </Row>
              <Row>
                <CancelButton onClick={closeModal} disabled={loading}>
                  Cancel
                </CancelButton>
                <ActionButton type="submit" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </ActionButton>
              </Row>
            </FieldGroup>
          </Form>
        </FormProvider>
      </Root>
    </Modal>
  )
}

export { PilotCategoryModal }
